import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const AddOutsourceShipmentTracking = ({ showModal, handleClose }) => {
 

  const [selectedRole, setSelectedRole] = useState('');
  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };
  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',

    color: '#333',
    width: '195px',
    height: "30px",
    cursor: 'pointer',
    marginLeft: '80px'
  };
  const [selectedRoled, setSelectedRoled] = useState('');
  const handleRoledChange = (event) => {
    setSelectedRoled(event.target.value);
  };
  const dropdownStyler = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',

    color: '#333',
    width: '194px',
    height: "30px",
    cursor: 'pointer',
    marginLeft: '110px'
  };
  const [inputValuer, setInputValuer] = useState('');
  const handleInputChanger = (event) => {
    setInputValuer(event.target.value);
  };
  const inputStyler = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '195px',
    height: "30px",
    marginLeft: "110px"
  };


  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton  style={{ backgroundColor: '#004aad' }}>
          <Modal.Title className='heading' style={{ color: 'white',fontSize:"20px" }}>Add OutSource Case ShipMent Tracking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
<h3>Add Outsource Case Shipment Tracking</h3>
<div style={{
                alignItems: 'center',
                fontSize: '0.9rem',
                marginRight: '20px',
                gap: '50px',
                backgroundColor: '#f2f2f2' 
            }}>
              <br></br>
        <b style={{marginLeft:"10px"}}>Direction * </b>
        <select
                  value={selectedRole}
                  onChange={handleRoleChange}
                  style={dropdownStyling}
                >
                  <option value=" "></option>
                  <option value="Shipping from Outsource partner to lab ">Shipping from Outsource partner to lab</option>
                  <option value=" Shipping from Outsource partner from lab">Shipping from Outsource partner from lab</option>
                 
                </select>
                <br></br>
                <br></br>
               <b style={{marginLeft:"10px"}}> Carrier</b>
               <select
                  value={selectedRoled}
                  onChange={handleRoledChange}
                  style={dropdownStyler}
                >
                  <option value=""></option>
                  <option value="U.S Postal service">U.S Postal service</option>
                  <option value="Stamps.com">Stamps.com</option>
                  <option value="FedEx">FedEx</option>
                  <option value="UPS">UPS</option>
                  <option value="DHL Express">DHL Express </option>
                  <option value="Canada Post">Canada Post</option>
                  <option value="Australia Post">Australia Post</option>
                  <option value="First Mile">First Mile </option>
                  <option value="Asendia">Asendia</option>
                  <option value="OnTrac"> OnTrac</option>
                  <option value="APC">APC </option>
                  <option value="Newgistics">Newgistics</option>
                  <option value="Globegistics">Globegistics</option>
                  <option value="RR Donnelly">RR Donnelly</option>
                  <option value="Access worldwide">Access worldwide</option>
                  <option value="Purolator Canada">Purolator Canada</option>
                  <option value="Sendle">Sendle</option>
                </select>
                <br></br>
                <br></br>
                <b style={{marginLeft:"10px"}}> Track#</b>
                <input
                  type="text"
                  value={inputValuer}
                  onChange={handleInputChanger}
                  style={inputStyler}
                  placeholder=""
                />
                <br></br>
                <br></br>
                </div>
        </Modal.Body>
        <Modal.Footer>
        <Button
  variant="secondary"
  onClick={handleClose}
  style={{
    backgroundColor: '#004aad',
    borderColor: '#004aad',  
  }}
>
  Cancel
</Button>
<Button
  variant="secondary"
  onClick={handleClose}
  style={{
    backgroundColor: '#004aad',
    borderColor: '#004aad',  
  }}
>
  Save
</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddOutsourceShipmentTracking;

